export default "/e891d4a0bdc60f2a6a9b4e97d7422547d2a79dc5/bafcb97f65150dd63b7cabadb0e0f790.svg";